var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTier1Img(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 350,
    viewBox: "0 0 417 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M194.339 13.0445C197.822 7.17054 206.324 7.17054 209.806 13.0445L305.13 173.834L394.788 333.352C398.515 339.983 392.837 347.957 385.352 346.604L203.671 313.771C202.614 313.58 201.531 313.58 200.474 313.771L18.793 346.604C11.3085 347.957 5.63052 339.983 9.35713 333.352L99.0156 173.834L194.339 13.0445Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M204.233 104.503C203.365 102.669 200.755 102.669 199.888 104.503L120.51 272.376C119.6 274.301 121.458 276.372 123.47 275.674L201.273 248.683C201.783 248.506 202.338 248.506 202.848 248.683L280.651 275.674C282.663 276.372 284.521 274.301 283.611 272.376L204.233 104.503Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M372.696 218.669L411.638 287.264",
    stroke: "#C4C4C4",
    strokeWidth: 8.99017,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M138.854 29.3359L54.06 172.375",
    stroke: "#C4C4C4",
    strokeWidth: 8.99017,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier1Img);
export default __webpack_public_path__ + "static/media/tier-1-img.19cfac11398eaaef282bebfe84a30594.svg";
export { ForwardRef as ReactComponent };